/* Full-size manual mobile gallery; desktop keeps its existing thumbnails. */
(() => {
 function init(root = document) {
  root.querySelectorAll('.pdp-gallery .pdp-thumbnails').forEach(track => {
   if (track.dataset.carouselReady) return;
   const slides = [...track.querySelectorAll('button')];
   const gallery = track.closest('.pdp-gallery');
   const stage = gallery.querySelector('.pdp-main-photo, .gallery-stage');
   if (slides.length < 2 || !stage) return;
   track.dataset.carouselReady = 'true';
   gallery.classList.add('has-mobile-gallery');
   const mobile = matchMedia('(max-width: 767px)');
   const reduced = matchMedia('(prefers-reduced-motion: reduce)');
   const previous = document.createElement('button'), next = document.createElement('button');
   previous.type = next.type = 'button';
   previous.className = 'mobile-gallery-arrow mobile-gallery-previous';
   next.className = 'mobile-gallery-arrow mobile-gallery-next';
   previous.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m14 6-6 6 6 6"/></svg>'; next.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="m10 6 6 6-6 6"/></svg>';
   previous.setAttribute('aria-label', 'Previous product image');
   next.setAttribute('aria-label', 'Next product image');

   const navigation = document.createElement('div');
   navigation.className = 'mobile-gallery-pagination';
   navigation.setAttribute('role', 'group');
   navigation.setAttribute('aria-label', 'Choose a product image');
   const status = document.createElement('span');status.className = 'mobile-gallery-status';
   status.setAttribute('role', 'status');status.setAttribute('aria-live', 'polite');
   navigation.append(previous, status, next);stage.after(navigation);
   const selected = () => Math.max(0, slides.findIndex(b => b.getAttribute('aria-pressed') === 'true'));
   function update() {
    const index = selected();status.textContent = `${index + 1} / ${slides.length}`;
    previous.disabled = index === 0;next.disabled = index === slides.length - 1;
   }
   function choose(index) {
    const before = selected();index = Math.max(0, Math.min(slides.length - 1, index));
    slides[index].click();update();
    if (mobile.matches && !reduced.matches && index !== before) {
     const image = stage.querySelector('#pdp-main-image, .gallery-panel:not([hidden]) img');
     image?.animate([{opacity:.55,transform:`translateX(${index > before ? 24 : -24}px)`},{opacity:1,transform:'translateX(0)'}],{duration:220,easing:'ease-out'});
    }
   }
   previous.addEventListener('click', () => choose(selected() - 1));
   next.addEventListener('click', () => choose(selected() + 1));
   let start, suppressClickUntil = 0;
   stage.addEventListener('pointerdown', event => {
    if (!mobile.matches || event.pointerType === 'mouse' || event.target.closest('.mobile-gallery-arrow')) return;
    start = {x:event.clientX,y:event.clientY};
   });
   stage.addEventListener('pointerup', event => {
    if (!start) return;
    const dx = event.clientX - start.x, dy = event.clientY - start.y;start = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
     suppressClickUntil = Date.now() + 400;choose(selected() + (dx < 0 ? 1 : -1));
    }
   });
   stage.addEventListener('pointercancel', () => {start = null;});
   stage.addEventListener('click', event => {if(Date.now() < suppressClickUntil){event.preventDefault();event.stopImmediatePropagation();}}, true);
   new MutationObserver(update).observe(track,{subtree:true,attributes:true,attributeFilter:['aria-pressed']});
   update();
  });
 }
 init();document.addEventListener('shopify:section:load', event => init(event.target));
})();
